import React from 'react';
import Field from '../Field';
// import {
//   StyledFieldTextareaLabel,
//   StyledFieldTextarea,
// } from './StyledFieldTextarea';

class FieldTextarea extends Field {
    constructor(props) {
        super(props);
    }
    handleClasses() {
        return super.handleClasses().concat(' field--textarea');
    }
    render() {
        return (
            <label
                className={this.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderTooltip()}
                {super.renderLabel()}
                {super.renderAutoresize()}
                <textarea
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...super.generateProps()}
                    cols={50}
                />
                {super.renderError()}
            </label>
        );
    }
}

export default FieldTextarea;
